import { createAction, props } from '@ngrx/store';
import { ServiceRequest } from 'src/app/models/service-request';

// Fetch all service requests
export const fetchServiceRequests = createAction(
  '[Service Request] Fetch All Initiated'
);
export const fetchServiceRequestsSuccess = createAction(
  '[Service Request] Fetch All Success',
  props<{ serviceRequests: ServiceRequest[] }>()
);
export const fetchServiceRequestsFailed = createAction(
  '[Service Request] Fetch All Failed',
  props<{ error: Error }>()
);

// Fetch service request by Id
export const fetchServiceRequestById = createAction(
  '[Service Request] Fetch By Id Initiated',
  props<{ serviceRequestId: string }>()
);
export const fetchCurrentServiceRequest = createAction(
  '[Service Request] Fetch Current Service Request Initiated'
);
export const fetchServiceRequestByIdSuccess = createAction(
  '[Service Request] Fetch By Id Success',
  props<{ serviceRequest: ServiceRequest }>()
);
export const fetchServiceRequestByIdFailed = createAction(
  '[Service Request] Fetch By Id Failed',
  props<{ error: Error }>()
);

// Recreate service request with specific ID
export const recreateServiceRequest = createAction(
  '[Service Request] Recreate Initiated',
  props<{ serviceRequestId: string; data: Partial<ServiceRequest> }>()
);
export const recreateServiceRequestSuccess = createAction(
  '[Service Request] Recreate Success',
  props<{ serviceRequest: ServiceRequest }>()
);
export const recreateServiceRequestFailed = createAction(
  '[Service Request] Recreate Failed',
  props<{ error: Error }>()
);
